import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Matrix4, Object3D, Vector2, Vector3 } from 'three';
var CSS2DObject = /*#__PURE__*/function (_Object3D) {
  _inherits(CSS2DObject, _Object3D);
  var _super = _createSuper(CSS2DObject);
  function CSS2DObject() {
    var _this2;
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');
    _classCallCheck(this, CSS2DObject);
    _this2 = _super.call(this);
    _this2.isCSS2DObject = true;
    _this2.element = element;
    _this2.element.style.position = 'absolute';
    _this2.element.style.userSelect = 'none';
    _this2.element.setAttribute('draggable', false);
    _this2.center = new Vector2(0.5, 0.5); // ( 0, 0 ) is the lower left; ( 1, 1 ) is the top right

    _this2.addEventListener('removed', function () {
      this.traverse(function (object) {
        if (object.element instanceof Element && object.element.parentNode !== null) {
          object.element.parentNode.removeChild(object.element);
        }
      });
    });
    return _this2;
  }
  _createClass(CSS2DObject, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(CSS2DObject.prototype), "copy", this).call(this, source, recursive);
      this.element = source.element.cloneNode(true);
      this.center = source.center;
      return this;
    }
  }]);
  return CSS2DObject;
}(Object3D); //
var _vector = new Vector3();
var _viewMatrix = new Matrix4();
var _viewProjectionMatrix = new Matrix4();
var _a = new Vector3();
var _b = new Vector3();
var CSS2DRenderer = /*#__PURE__*/_createClass(function CSS2DRenderer() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, CSS2DRenderer);
  var _this = this;
  var _width, _height;
  var _widthHalf, _heightHalf;
  var cache = {
    objects: new WeakMap()
  };
  var domElement = parameters.element !== undefined ? parameters.element : document.createElement('div');
  domElement.style.overflow = 'hidden';
  this.domElement = domElement;
  this.getSize = function () {
    return {
      width: _width,
      height: _height
    };
  };
  this.render = function (scene, camera) {
    if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
    if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
    _viewMatrix.copy(camera.matrixWorldInverse);
    _viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, _viewMatrix);
    renderObject(scene, scene, camera);
    zOrder(scene);
  };
  this.setSize = function (width, height) {
    _width = width;
    _height = height;
    _widthHalf = _width / 2;
    _heightHalf = _height / 2;
    domElement.style.width = width + 'px';
    domElement.style.height = height + 'px';
  };
  function renderObject(object, scene, camera) {
    if (object.isCSS2DObject) {
      _vector.setFromMatrixPosition(object.matrixWorld);
      _vector.applyMatrix4(_viewProjectionMatrix);
      var visible = object.visible === true && _vector.z >= -1 && _vector.z <= 1 && object.layers.test(camera.layers) === true;
      object.element.style.display = visible === true ? '' : 'none';
      if (visible === true) {
        object.onBeforeRender(_this, scene, camera);
        var element = object.element;
        element.style.transform = 'translate(' + -100 * object.center.x + '%,' + -100 * object.center.y + '%)' + 'translate(' + (_vector.x * _widthHalf + _widthHalf) + 'px,' + (-_vector.y * _heightHalf + _heightHalf) + 'px)';
        if (element.parentNode !== domElement) {
          domElement.appendChild(element);
        }
        object.onAfterRender(_this, scene, camera);
      }
      var objectData = {
        distanceToCameraSquared: getDistanceToSquared(camera, object)
      };
      cache.objects.set(object, objectData);
    }
    for (var i = 0, l = object.children.length; i < l; i++) {
      renderObject(object.children[i], scene, camera);
    }
  }
  function getDistanceToSquared(object1, object2) {
    _a.setFromMatrixPosition(object1.matrixWorld);
    _b.setFromMatrixPosition(object2.matrixWorld);
    return _a.distanceToSquared(_b);
  }
  function filterAndFlatten(scene) {
    var result = [];
    scene.traverse(function (object) {
      if (object.isCSS2DObject) result.push(object);
    });
    return result;
  }
  function zOrder(scene) {
    var sorted = filterAndFlatten(scene).sort(function (a, b) {
      if (a.renderOrder !== b.renderOrder) {
        return b.renderOrder - a.renderOrder;
      }
      var distanceA = cache.objects.get(a).distanceToCameraSquared;
      var distanceB = cache.objects.get(b).distanceToCameraSquared;
      return distanceA - distanceB;
    });
    var zMax = sorted.length;
    for (var i = 0, l = sorted.length; i < l; i++) {
      sorted[i].element.style.zIndex = zMax - i;
    }
  }
});
export { CSS2DObject, CSS2DRenderer };